<h1 mat-dialog-title>Loading data</h1>
<div mat-dialog-content>
  Please have a moment of patience
</div>
<div mat-dialog-actions>
  <div class="loading-spinner">
    <mat-spinner diameter="40" strokeWidth="2"></mat-spinner>
  </div>
</div>
